/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useImmer } from "use-immer";
import { usePermission } from "../../../shared";
import { AppContext } from "../../../store/AppScopeProvider";
import { errorMessage, } from "../../../utils";
import {
  getClientAccountsList,
} from "../api";
import qs from "qs";
import { useDebouncedCallback } from "use-debounce";
import { TableStateContext } from "../../../store";

export const useClientAccountList = ({ isList }) => {
  const { appState } = useContext(AppContext);
  const {
    currentTabs: { clientAccV2List: currentTab },
  } = appState;

  const isEditable = usePermission("client-account-modify");
  const isDeletable = usePermission("client-account-delete");
  const isCreateVisible = usePermission("client-account-create");

  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const [state, setState] = useImmer({
    isLoading: true,
    dataList: [],
    filters: {
      isOpen: false,
      isSearching: false,
      all: [],
      searchText: "",
      stores: [],
      status: "",
      credit_limit_operator: "",
      due_amount_operator: "",
      credit_limit_value: "",
      due_amount_value: "",
    },
  })

  const PAGE_NAME = "clientAccountV2";
  const {
    filterState: {
      params: { clientAccountV2 },
    },
    // initialState,
    filterStateDispatch,
  } = useContext(TableStateContext);



  const handleClientAccountList = async (
    stores = [],
    searchText = "",
    status = "",
    credit_limit_operator = "",
    due_amount_operator = "",
    credit_limit_value = "",
    due_amount_value = ""
  ) => {
    let params = {};
    let IDs = stores.map((v) => {
      return v.value;
    });
    if (searchText) {
      params = { ...params, search: searchText };
    }
    if (status && toString(status.value)) {
      params = { ...params, status: status.value };
    }
    if (IDs.length > 0) {
      params = { ...params, store_id: IDs };
    }
    if (credit_limit_operator && toString(credit_limit_operator)) {
      params = {
        ...params,
        credit_limit_operator: credit_limit_operator.value,
      };
    }
    if (credit_limit_value && toString(credit_limit_value)) {
      params = {
        ...params,
        credit_limit_value: credit_limit_value.value,
      };
    }
    if (due_amount_value && toString(due_amount_value)) {
      params = {
        ...params,
        due_amount_value: due_amount_value.value,
      };
    }
    if (due_amount_operator && toString(due_amount_operator)) {
      params = {
        ...params,
        due_amount_operator: due_amount_operator.value,
      };
    }
    const query = {
      params,
      paramsSerializer: (params) => qs.stringify(params),
    };
    try {
      setState((draft) => {
        draft.isLoading = true;
        // draft.initialLoad = true;
      });
      const res = await getClientAccountsList(query);
      if (res.success) {
        setState((draft) => {
          draft.dataList = res.data;
          draft.initialLoad = false;
          draft.isLoading = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
        draft.initialLoad = false;
      });
    }
  };

  useEffect(() => {
    if (isList) {
      const {
        stores,
        status,
        searchText,
        credit_limit_operator,
        due_amount_operator,
        credit_limit_value,
        due_amount_value,
      } = clientAccountV2.filterApplied;
      setState((draft) => {
        draft.filters = clientAccountV2.filterApplied;
      });
      handleClientAccountList(
        stores,
        searchText,
        status,
        credit_limit_operator,
        due_amount_operator,
        credit_limit_value,
        due_amount_value
      );
    }
  }, [isList]);

  const handleFilterClear = (type, value) => {
    const {
      stores,
      searchText,
      status,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value,
    } = state.filters;

    if (type === "single") {
      if (value.type === "Store") {
        const filteredStores = state.filters.stores.filter(
          (e) => e.value !== value.value
        );
        handleClientAccountList(
          filteredStores,
          searchText,
          status,
          credit_limit_operator,
          due_amount_operator,
          credit_limit_value,
          due_amount_value
        );
        setState((draft) => {
          draft.filters.stores = filteredStores;
        });
        filterStateDispatch({
          type: "SET_DATA",
          page: PAGE_NAME,
          data: {
            filterApplied: { ...state.filters, stores: filteredStores },
          },
        });
      } else if (value?.type === "Status") {
        handleClientAccountList(
          stores,
          searchText,
          "",
          credit_limit_operator,
          due_amount_operator,
          credit_limit_value,
          due_amount_value
        );
        setState((draft) => {
          draft.filters.status = "";
        });
        filterStateDispatch({
          type: "SET_DATA",
          page: PAGE_NAME,
          data: {
            filterApplied: { ...state.filters, status: "" },
          },
        });
      } else if (value?.type === "credit_limit_operator") {
        handleClientAccountList(
          stores,
          searchText,
          status,
          "",
          due_amount_operator,
          credit_limit_value,
          due_amount_value
        );
        setState((draft) => {
          draft.filters.credit_limit_operator = "";
        });
        filterStateDispatch({
          type: "SET_DATA",
          page: PAGE_NAME,
          data: {
            filterApplied: { ...state.filters, credit_limit_operator: "" },
          },
        });
      } else if (value?.type === "due_amount_operator") {
        handleClientAccountList(
          stores,
          searchText,
          status,
          credit_limit_operator,
          "",
          credit_limit_value,
          due_amount_value
        );
        setState((draft) => {
          draft.filters.due_amount_operator = "";
        });
        filterStateDispatch({
          type: "SET_DATA",
          page: PAGE_NAME,
          data: {
            filterApplied: { ...state.filters, due_amount_operator: "" },
          },
        });
      } else if (value?.type === "credit_limit_value") {
        handleClientAccountList(
          stores,
          searchText,
          status,
          credit_limit_operator,
          due_amount_operator,
          "",
          due_amount_value
        );
        setState((draft) => {
          draft.filters.credit_limit_value = "";
        });
        filterStateDispatch({
          type: "SET_DATA",
          page: PAGE_NAME,
          data: {
            filterApplied: { ...state.filters, credit_limit_value: "" },
          },
        });
      } else if (value?.type === "due_amount_value") {
        handleClientAccountList(
          stores,
          searchText,
          status,
          credit_limit_operator,
          due_amount_operator,
          credit_limit_value,
          ""
        );
        setState((draft) => {
          draft.filters.due_amount_value = "";
        });
        filterStateDispatch({
          type: "SET_DATA",
          page: PAGE_NAME,
          data: {
            filterApplied: { ...state.filters, due_amount_value: "" },
          },
        });
      }
    } else {
      handleClientAccountList([], searchText, "", "", "", "", "");
      setState((draft) => {
        draft.filters.all = [];
        draft.filters.stores = [];
        draft.filters.status = "";
        draft.filters.credit_limit_operator = "";
        draft.filters.due_amount_operator = "";
        draft.filters.credit_limit_value = "";
        draft.filters.due_amount_value = "";
      });

      const initialValue = {
        isOpen: false,
        isSearching: false,
        all: [],
        searchText: "",
        stores: [],
        status: "",
        credit_limit_operator: "",
        due_amount_operator: "",
        credit_limit_value: "",
        due_amount_value: "",
      };
      filterStateDispatch({
        type: "CLEAR_FILTERS",
        page: PAGE_NAME,
        value: initialValue,
      });
    }
  };

  const debounced = useDebouncedCallback((value) => {
    const {
      stores,
      status,
      searchText,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value,
    } = state.filters;
    filterStateDispatch({
      type: "SET_DATA",
      page: PAGE_NAME,
      data: { filterApplied: state.filters },
    });
    handleClientAccountList(
      stores,
      searchText,
      status,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value
    );
  }, 1000);

  const handleSearch = (v) => {
    debounced(v);
    setState((draft) => {
      draft.filters.searchText = v;
    });
    filterStateDispatch({
      type: "SET_DATA",
      page: PAGE_NAME,
      data: {
        filterApplied: { ...state.filters, searchText: v },
      },
    });
  };
  const onSeachClear = () => {
    setState((draft) => {
      draft.filters.searchText = "";
      draft.filters.isSearching = true;
    });
    const {
      stores,
      status,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value,
    } = state.filters;
    handleClientAccountList(
      stores,
      "",
      status,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value
    );
    filterStateDispatch({
      type: "SET_DATA",
      page: PAGE_NAME,
      data: { filterApplied: { ...state.filters, searchText: "" } },
    });
  };

  const onChangeFilter = (e) => {
    setState((draft) => {
      draft.filters.searchText = e.target.value;
      draft.filters.isSearching = false;
    });
    debounced(e.target.value);
    filterStateDispatch({
      type: "SET_DATA",
      page: PAGE_NAME,
      data: {
        filterApplied: { ...state.filters, searchText: e.target.value },
      },
    });
  };

  const handleApplyFilter = () => {
    const {
      stores,
      searchText,
      status,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value,
    } = state.filters;
    handleClientAccountList(
      stores,
      searchText,
      status,
      credit_limit_operator,
      due_amount_operator,
      credit_limit_value,
      due_amount_value
    );
    filterStateDispatch({
      type: "SET_DATA",
      page: PAGE_NAME,
      data: {
        filterApplied: { ...state.filters },
      },
    });
  };
  const handleFilter = (e, value, type) => {
    if (type === "store") {
      setState((draft) => {
        draft.filters.stores = value.map((v) => {
          return { ...v, type: "Store" };
        });
      });
    } else if (type === "status") {
      setState((draft) => {
        draft.filters.status = {
          value: value.props.value,
          label: value.props.children,
          type: "Status",
        };
      });
    } else if (type === "credit_limit_operator") {
      setState((draft) => {
        draft.filters.credit_limit_operator = {
          value: value?.props?.value,
          label: value?.props?.children,
          type: "credit_limit_operator",
        };
      });
    } else if (type === "due_amount_operator") {
      setState((draft) => {
        draft.filters.due_amount_operator = {
          value: value?.props?.value,
          label: value?.props?.children,
          type: "due_amount_operator",
        };
      });
    } else if (type === "credit_limit_value") {
      setState((draft) => {
        draft.filters.credit_limit_value = {
          value: e,
          label: e,
          type: "credit_limit_value",
        };
      });
    } else if (type === "due_amount_value") {
      setState((draft) => {
        draft.filters.due_amount_value = {
          value: e,
          label: e,
          type: "due_amount_value",
        };
      });
    }
  };

  useEffect(() => {
    let allData = [
      ...state.filters.stores,
      state.filters.status,
      state.filters.credit_limit_operator,
      state.filters.credit_limit_value,
      state.filters.due_amount_operator,
      state.filters.due_amount_value,
    ].filter((el) => Object.keys(el).length);
    setState((draft) => {
      draft.filters.all = allData;
    });
    filterStateDispatch({
      type: "SET_DATA",
      page: PAGE_NAME,
      data: {
        filterApplied: { ...state.filters, all: allData },
      },
    });
  }, [
    state.filters.credit_limit_operator,
    state.filters.stores,
    state.filters.status,
    state.filters.due_amount_operator,
    state.filters.credit_limit_value,
    state.filters.due_amount_value,
  ]);


  return {
    state,
    currentTab,
    isEditable,
    isDeletable,
    isCreateVisible,
    isStoreAdmin,
    handleFilterClear,
    onSeachClear,
    onChangeFilter,
    handleFilter,
    handleApplyFilter,
  };
};
